// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};


export const AD = {
    "nodejs_service_url": "http://10.1.2.13:3242/api/auth/ad",
    "username": "nodejsuser",
    "password": "nodejspass"
  }
  export const auth_server = {
    "auth": "https://127.0.0.1/users/auth",
    "verify": "https://127.0.0.1/users/verify",
    "getAll": "https://127.0.0.1/users/getAll",
    "create": "https://127.0.0.1/users/create",
    "update": "https://127.0.0.1/users/updateById",
    "delete": "https://127.0.0.1/users/deleteById",
    "getById":"https://127.0.0.1/users/getById"
  }
  export const home = {
    "statistics":"https://127.0.0.1/homeData",
    "bulkActions":"https://127.0.0.1/bulkActions",
    "reportIssue":"https://127.0.0.1/reportIssue"
  }
  export const user_access = {
    "url": "https://127.0.0.1/userdata",
    "newrequest_url": "https://127.0.0.1/newrequest",
    "check_newrequest_by_user_url": "https://127.0.0.1/requestbyuser",
    "new_user_session": "https://127.0.0.1/newsession",
    "update_user_session": "https://127.0.0.1/updatesession"
  }
  export const folder_manager = {
    "add_folder": "https://127.0.0.1/foldermanagement",
    "get_folder_id_by_name": "https://127.0.0.1/foldermanagement",
    "ngx_tree": "https://127.0.0.1/ngxtree"
  }
  export const system_manager = {
    "services": "https://127.0.0.1/systemmanagement",
    "pull_system_profile": "https://127.0.0.1/pullprofile",
    "push_system_profile": "https://127.0.0.1/pushprofile",
    "update_profile":"https://127.0.0.1/updateProfile"
  }
  export const template_manager = {

    "services": "https://127.0.0.1/templatemodule",
    "templatecommandsview": "https://127.0.0.1/templatecommandsview",
    "table_dataset": "https://127.0.0.1/tabledataset"
  }
  export const software_update = {
    "services": "https://127.0.0.1/softwareupgrade",
    "package_directory": "E:\\RTC_Dev\\RTC_Monitoring\\Backend\\nodejs\\uploads"
  }
  export const phonebook = {
    "phonebook_management": "https://127.0.0.1/phonebookmanagement",
    "catalog_management": "https://127.0.0.1/catalogmanagement",
    "phonebookcatalog_management": "https://127.0.0.1/phonebookcatalogmanagement",
    "entry_management": "https://127.0.0.1/entrymanagement",
    "route_management": "https://127.0.0.1/routemanagement",
    "phonebook_task_management": "https://127.0.0.1/phonebooktaskmanagement"
  }
  export const searchModule = {
    "postSearch": "https://127.0.0.1/search"
  }
  export const logs = {
    "getLogs": "https://127.0.0.1/getlogs"
  }
  export const logger ={
    "logEntry":"https://127.0.0.1/fe_logging"

  }



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
